if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });
    $('ul.slick-dots button').each(function(element, index){
        if($(this).text() < 10){
            $(this).html('0' + $(this).text());
            var label = $(this).text();
            console.log(label);
            $(this).attr('aria-label', label+' of '+ $(element).length);
        }
    });

    // $('.sym-slides').each(function(element, index){
    //     if($(this).text() < 10){
    //         $(this).html('0' + $(this).text());
    //         var label = $(this).text();
    //         console.log(label);
    //         $(this).attr('aria-label', label+' of '+ $('ul.slick-dots button',element).length);
    //     }
    // });

})();